module.exports = __webpack_public_path__ + "static/media/terrace-8.951fc6a0.jpg";